import { render, staticRenderFns } from "./DeviceFilterReviewsSkeleton.vue?vue&type=template&id=37d742a7&"
import script from "./DeviceFilterReviewsSkeleton.vue?vue&type=script&lang=js&"
export * from "./DeviceFilterReviewsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d742a7')) {
      api.createRecord('37d742a7', component.options)
    } else {
      api.reload('37d742a7', component.options)
    }
    module.hot.accept("./DeviceFilterReviewsSkeleton.vue?vue&type=template&id=37d742a7&", function () {
      api.rerender('37d742a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceFilterReviewsSkeleton.vue"
export default component.exports